import React from 'react';
import './Skeleton.scss'

const Skeleton = () => {
    return (
        <div className='shimmer w-100 h-100'></div>
    );
};

export default Skeleton;